import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "decrementButton",
    "incrementButton",
    "displayButton",
    "displayValue",
    "expanded",
  ];
  static values = {
    placeholder: String,
    oneYear: String,
    multipleYears: String,
  };

  connect() {
    this.updateButtonStates();
    this.updateDisplay();
    // Start in collapsed state
    this.collapse();
  }

  expand() {
    this.displayButtonTarget.classList.add("hidden");
    this.expandedTarget.classList.remove("hidden");
    this.expandedTarget.classList.add("flex");
    // Focus the input after a brief delay to ensure transition starts
    setTimeout(() => this.inputTarget.focus(), 50);
  }

  collapse(event) {
    // Delay collapse to check if user clicked increment/decrement buttons
    this.collapseTimeout = setTimeout(() => {
      this.expandedTarget.classList.add("hidden");
      this.expandedTarget.classList.remove("flex");
      this.displayButtonTarget.classList.remove("hidden");
      this.updateDisplay();
    }, 150);
  }

  cancelCollapse() {
    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout);
      this.collapseTimeout = null;
    }
  }

  increment() {
    this.cancelCollapse();
    const currentValue = parseInt(this.inputTarget.value) || 0;
    if (currentValue < 99) {
      this.inputTarget.value = currentValue + 1;
      this.updateButtonStates();
      this.emitSyncEvent();
    }
    // Keep focus on input
    this.inputTarget.focus();
  }

  decrement() {
    this.cancelCollapse();
    const currentValue = parseInt(this.inputTarget.value) || 0;
    if (currentValue > 0) {
      this.inputTarget.value = currentValue - 1;
    } else {
      this.inputTarget.value = 0;
    }
    this.updateButtonStates();
    this.emitSyncEvent();
    // Keep focus on input
    this.inputTarget.focus();
  }

  validateInput() {
    let value = parseInt(this.inputTarget.value);

    if (isNaN(value) || value < 0) {
      this.inputTarget.value = 0;
    } else if (value > 99) {
      this.inputTarget.value = 99;
    }

    this.updateButtonStates();
    this.emitSyncEvent();
  }

  emitSyncEvent() {
    window.dispatchEvent(new CustomEvent("search-field:changed", {
      detail: {
        field: "age",
        value: this.inputTarget.value,
        source: this.element
      }
    }));
  }

  updateButtonStates() {
    const value = parseInt(this.inputTarget.value) || 0;

    this.decrementButtonTarget.disabled = value <= 0;
    this.incrementButtonTarget.disabled = value >= 99;
  }

  updateDisplay() {
    const value = parseInt(this.inputTarget.value);

    if (isNaN(value) || value === 0) {
      // No age set - hide the value display completely
      this.displayValueTarget.textContent = "";
      this.displayValueTarget.classList.add("hidden");
    } else {
      // Age is set - show formatted age
      const ageText =
        value === 1
          ? this.oneYearValue
          : this.multipleYearsValue.replace("%{count}", value);
      this.displayValueTarget.textContent = ageText;
      this.displayValueTarget.classList.remove("hidden");
    }
  }
}
